import { gql } from '@apollo/client';

export const DELETE_RATE_CARD = gql`
  mutation DeleteRateCard($uid: String!) {
    deleteRateCard(uid: $uid) {
      name
      referenceCode
    }
  }
`;

export default DELETE_RATE_CARD;
